import React from 'react';
import { useTranslate } from 'nucleus-text';
import { PageAlert } from '@cvent/carina/components/Alert';

import { useAlert } from '@components/providers/ErrorProvider';

type AlertProps = {
  testID: string;
};

export const Alert = ({ testID }: AlertProps) => {
  const { translate } = useTranslate();
  const { alert } = useAlert();

  if (Object.keys(alert).length === 0) return null;
  return (
    <PageAlert
      testID={`${testID}_alert`}
      appearance={alert.type}
      content={translate(alert.message, alert.props)}
      isRtl={false}
      dismissible={false}
    />
  );
};
